import { PageAnalyticsWithPostsBase } from 'mewe/routes/app/publicid/statistics/index';

export default PageAnalyticsWithPostsBase.extend({
  showFollowersInOverview: false,
});
